var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useAnalytics } from 'hx-analytics';
import { imageManWithEarphone } from 'hx-assets';
import { NavButtons } from 'hx-navigator';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { StepLayout } from '@/components/step-layout.component';
import { LexieButton } from '@/components/lexie-button.component';
export var CompletePage = function () {
    var rootState = useSelector(function (state) { return state; });
    var sendButtonClick = useAnalytics(rootState).sendButtonClick;
    var navigate = useNavigate();
    var handleEndSessionClick = function () {
        navigate('/');
        sendButtonClick('session-end');
    };
    return (_jsx(StepLayout, { image: imageManWithEarphone, heading: "Well done on taking the first step in your hearing health journey.", content: _jsx(_Fragment, { children: _jsx(Typography, __assign({ variant: "info", className: "max-w-[50ch] self-start" }, { children: "A product expert will be in touch shortly." })) }), nav: _jsx(NavButtons, __assign({ col: true, className: "px-12" }, { children: _jsx(LexieButton, __assign({ variant: "contained", onClick: handleEndSessionClick }, { children: "End session" })) })) }));
};
